import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { CrudBqResponse } from './types';

export const investorEndpoint = {
  server: defaultServer,
  path: 'crud/investor',
  description: 'Investor operations',
};

const endpointInvestorExec =
  getExecEndpoint<InvestorEndpointDef>(investorEndpoint);

export const endpointInvestorGET = async () => {
  const response = await endpointInvestorExec<'GET'>({
    method: 'GET',
  });

  if (!response) {
    throw new Error('Could not get sectors');
  }

  if (response.success === 0) {
    throw new Error('Could not get sectors');
  }

  return response;
};

export interface InvestorEndpointDef {
  endpoint: typeof investorEndpoint;
  methods: {
    GET: {
      response: InvestorGetDataResponse;
    };
  };
}

export type SectorPostResponse = CrudBqResponse<{ id: string }>;

export type InvestorGetDataResponse = CrudBqResponse<InvestorGetData[]>;

export type InvestorPostPayload = Omit<
  InvestorGetData,
  'id' | 'createdAt' | 'updatedAt'
>;

export type InvestorGetData = {
  id: string;
  name: string;
  type: string;
  investorFundId: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
};
